import {
  PLANS_START,
  PLANS_VE_START,
  PLANS_SUCCESS,
  PLANS_FINISH,
  PLAN_DEFAULT_SELECTED,
  PLAN_SELECTED,
  TYPE_OF_FINANCING,
  NAME_PLAN_SELECTED,
  COVERAGE_PLAN,
  SPECIAL_COVERAGE,
  PLAN_SAVING_SELECTED,
  SET_NAME_FREQUENCY,
  ADD_THIRD_INIT,
  ADD_THIRD_SUCCESS,
  PLAN_SUM_ASSURED,
  PLAN_SAVING_TIME,
  PLAN_RETURN_PERCENTAGE,
  SAVE_PLAN_ID,
  SET_CURRENCY_PLAN,
  SET_MAX_AMOUNT_QUOTE,
  SET_FINANCIAL_ENTITIES,
  SET_SUM_ASSURED,
  SET_PREFETCHED_SUM_ASSURED,
} from "../types/plans";
import url from "../../utils/url";
import HTTP_REQUEST from "../../utils/http";
import { API_CANAL } from "../../utils/consts";
import { changeGlobalState } from "./global";
import helpers from "../../utils/helpers";
import {
  formatExactSelect,
  formatAmountThousand,
  deleteDuplicateObject,
  removeItemsArrayFromArray,
} from "../../utils/Utils";
import { decryptAES, encryptAES } from "../../utils/CryptographyUtils";
import { getCodeSecurity } from "../../utils/apiCanal";
import {
  SUMA_ASEGURADA_EXCLUIDA,
  TIEMPO_AHORRO_EXCLUIDO,
  PORCENTAJE_DEV_EXCLUIDO,
} from "../../utils/awsConfig";

const LIMIT_PERMANENCY_AGE = 77; /* Edad máxima de permanencia en el seguro */

export const createQuote = (request) => async (dispatch) => {
  dispatch({ type: PLANS_START });
  try {
    const plans = await HTTP_REQUEST.postWitchTrace(
      url.obtenerPlanes,
      request,
      "APIS_VCT",
      API_CANAL
    );
    const { payload, status } = plans.response;
    /* let payload = JSON.parse(decryptAES(payloadEncrypt, getCodeSecurity()));
    if (typeof payload === 'string') {
      payload = JSON.parse(payload);
    } */
    if (status.success) {
      const sortPlans = payload.sort((planA, planB) => {
        return planA.plan.aniosPlan - planB.plan.aniosPlan;
      });
      dispatch({
        type: PLANS_SUCCESS,
        data: sortPlans,
      });
    } else {
      dispatch(changeGlobalState(4));
    }
    return payload;
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.obtenerPlanes);
  } finally {
    dispatch({
      type: PLANS_FINISH,
    });
  }
};

export const getAttribute = (request, type, clientAge) => async (dispatch) => {
  const applyFilter = localStorage.getItem("origen_venta") !== "webcall";
  try {
    const {
      response: { payload, status },
    } = await HTTP_REQUEST.postWitchTrace(
      url.obtenerAtributoValor,
      request,
      "APIS_VCT",
      API_CANAL
    );
    if (status.success) {
      let attributeFormated;
      switch (type) {
        case "sumAssured":
          let itemsSumAssured = payload.payload;
          if (applyFilter) {
            itemsSumAssured = removeItemsArrayFromArray(
              itemsSumAssured,
              SUMA_ASEGURADA_EXCLUIDA,
              "dscValor"
            );
          }
          attributeFormated = formatExactSelect(itemsSumAssured, {
            value: "ideValor",
            text: "dscValor",
          });
          attributeFormated.map(
            (item) => (item.text = `S/ ${formatAmountThousand(item.text)}`)
          );
          break;
        case "savingTime":
          let itemsSavingTime = payload.payload;
          if (applyFilter) {
            itemsSavingTime = removeItemsArrayFromArray(
              itemsSavingTime,
              TIEMPO_AHORRO_EXCLUIDO,
              "valor"
            );
          }
          attributeFormated = formatExactSelect(itemsSavingTime, {
            value: "ideValor",
            text: "valor",
          });
          const limitSavingTime = LIMIT_PERMANENCY_AGE - (clientAge || 0);
          const savingTimeValues = attributeFormated.filter(
            (e) => e.text <= limitSavingTime
          );
          attributeFormated = savingTimeValues;
          attributeFormated.map((item) => (item.text = `${item.text} años`));
          break;
        case "returnPercentage":
          let itemsReturnPercentage = payload;
          if (applyFilter) {
            const resultFilterDuplicate = deleteDuplicateObject(
              itemsReturnPercentage,
              "dscValor"
            );
            itemsReturnPercentage = removeItemsArrayFromArray(
              resultFilterDuplicate,
              PORCENTAJE_DEV_EXCLUIDO,
              "dscValor"
            );
          }
          attributeFormated = formatExactSelect(itemsReturnPercentage, {
            value: "ideValor",
            text: "dscValor",
          });
          attributeFormated.sort((a, b) => Number(a.text) - Number(b.text));
          attributeFormated.map((item) => (item.text = `${item.text}%`));
          break;
        default:
          break;
      }
      return deleteDuplicateObject(attributeFormated, "text");
    } else {
      dispatch(changeGlobalState(4));
    }
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.obtenerAtributoValor);
  }
};

export const selectQuote = (request) => async (dispatch) => {
  try {
    const { response } = await HTTP_REQUEST.postWitchTrace(
      url.seleccionarPlan,
      request,
      "APIS_VCT",
      API_CANAL
    );
    if (response.status) {
      return response;
    } else {
      dispatch(changeGlobalState(4));
    }
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.seleccionarPlan);
  }
};

export const addThirdToQuote = (userData, domicilio, plans) => async (
  dispatch
) => {
  try {
    const user = {
      codTercero:
        userData.tercero === "null" || !userData.tercero
          ? undefined
          : Number(userData.tercero),
      tipoDocumento: Number(userData.tipoDocumento || userData.typeDoc),
      numeroDocumento: userData.numeroDocumento || userData.documento,
      nombre: (userData.nombres ?? "").trim(),
      apePaterno: (userData.apellidoPaterno ?? "").trim(),
      apeMaterno: (userData.apellidoMaterno ?? "").trim(),
      sexo: userData.sexo,
      fecNacimiento: userData.fechaNacimiento || userData.fecNac,
      ubigeo: domicilio.ubigeo,
      tipoVia: domicilio.tipoVia.id,
      nombreVia: (domicilio.nombreVia ?? "").trim(),
      numeroVia: domicilio.numeroVia,
      correo: userData.correo,
      telefono: userData.telefono,
      proteccionDatosPersonales: "S",
      envioComunicacionesComerciales: "S",
      porcentajeParticipacion: 100,
    };

    const data = {
      ideTransaccion: plans.ideTransaccion,
      terceros: encryptAES(
        JSON.stringify([
          { ...user, ideRol: 8 },
          { ...user, ideRol: 23 },
        ]),
        getCodeSecurity()
      ),
      asegurados: encryptAES(
        JSON.stringify([
          {
            ...user,
            ideRol: 9,
            ideTipoRelTer: 134,
            ideAsegurado: 0,
            beneficiarios: [],
          },
        ]),
        getCodeSecurity()
      ),
      encriptado: true,
    };

    const { response } = await HTTP_REQUEST.postWitchTrace(
      url.agregarTercero,
      data,
      "APIS_VCT",
      API_CANAL
    );

    if (response.status) {
      dispatch({ type: ADD_THIRD_SUCCESS });
      return response;
    } else {
      dispatch(changeGlobalState(4));
    }
  } catch (error) {
    dispatch(changeGlobalState(4));
    helpers.sendTagError(error, url.beneficiaries);
  }
};

export const resetPlans = () => ({
  type: PLANS_START,
});

export const resetPlansVe = () => ({
  type: PLANS_VE_START,
});

export const planDefaultSelected = (data) => ({
  type: PLAN_DEFAULT_SELECTED,
  data,
});

export const planSelected = (data) => ({
  type: PLAN_SELECTED,
  data,
});

export const typeOfFinancing = (data) => ({
  type: TYPE_OF_FINANCING,
  data,
});

export const namePlanSelected = (data) => ({
  type: NAME_PLAN_SELECTED,
  data,
});

export const coveragePlan = (data) => ({
  type: COVERAGE_PLAN,
  data,
});

export const specialCoverageSelected = (data) => ({
  type: SPECIAL_COVERAGE,
  data,
});

export const planSavingSelected = (data) => ({
  type: PLAN_SAVING_SELECTED,
  data,
});

export const setNameFrequency = (data) => ({
  type: SET_NAME_FREQUENCY,
  data,
});

export const resetThirdState = () => ({
  type: ADD_THIRD_INIT,
});

export const savePlanId = (planId) => ({
  type: SAVE_PLAN_ID,
  data: planId,
});

export const setCurrencyPlan = (currency) => ({
  type: SET_CURRENCY_PLAN,
  data: currency,
})

export const setMaxAmountQuote = (maxAmount) => ({
  type: SET_MAX_AMOUNT_QUOTE,
  data: maxAmount,
});

export const setFinancialEntities = (entities) => ({
  type: SET_FINANCIAL_ENTITIES,
  data: entities,
});

export const setSumAssured = (sumAssured) => ({
  type: SET_SUM_ASSURED,
  data: sumAssured,
})

export const setPrefetchedSumAssured = (prefetchedSumAssured) => ({
  type: SET_PREFETCHED_SUM_ASSURED,
  data: prefetchedSumAssured,
})
